//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {addToClipboard} from "~/helpers/clipboard";

export default {
  name: 'TestingApiMethod',

  data: function () {
    return {
      form: {
        api_key: this.userApiKey || ""
      },

      result: null,
      resultUrl: null,
      isLoadResult: false
    }
  },

  props: {
    cfgs: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    parameters: function () {
      return this.cfgs?.parameters || []
    },

    userApiKey: function () {
      return this.$store.state?.user?.user?.dynamicFields?.settings?.apiKey || ""
    },
  },

  components: {
    ComponentApi: () => import("~/components/api-docs/testing-api-method/ComponentApi.vue"),
    ComponentSelect: () => import("~/components/api-docs/testing-api-method/ComponentSelect.vue"),
    ComponentString: () => import("~/components/api-docs/testing-api-method/ComponentString.vue"),
  },

  watch: {
    userApiKey: function () {
      let form = {...this.form};
      form['api_key'] = this.userApiKey;
      this.form = form;
    }
  },

  mounted: function () {
    let form = {...this.form};
    if (!form.api_key && this.userApiKey) {
      form.api_key = this.userApiKey;
      this.form = form;
    }
  },

  methods: {
    changeForm: function ({ name, value }) {
      let _form = {...this.form};
      _form[name] = value;
      this.form = _form;
    },

    getResult: async function () {
      let checkErrors = [];
      this.parameters.map((parameter) => {
        if (!this.form[parameter?.key]) {
          checkErrors.push(`${this.$t('documentationApi.fillIn')} "${ parameter?.key_label }"`)
        }
      });
      if (checkErrors.length > 0) {
        this.$toast.error(checkErrors.join(';<br/>'))
        return
      }

      if (this.isLoadResult) {
        return
      }
      this.isLoadResult = true;

      let apiUrl = String(this.cfgs?.url || '');
      Object.keys(this.form).map((formKey) => {
        apiUrl = apiUrl.replace(`$${ formKey }`, this.form[formKey])
      });

      const result = await this.$api.agent.transport.get(apiUrl)
        .then((res) => (res?.data || "Not found"))
        .catch(() => "Not found")

      this.result = result;
      this.resultUrl = apiUrl || "";
      this.isLoadResult = false;
    },

    copyResultUrl: async function () {
      await addToClipboard(this.resultUrl);
      this.$toast.success(this.$t('copyToBuffer.success'));
    },
  }
}
